import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
// NOTE: Please, don't remove these imports as they're necessary for displaying our translations with different locales
// Necessary for displaying dates with Arabic translations
import 'moment/dist/locale/ar'
// Necessary for displaying dates with Bulgarian translations
import 'moment/dist/locale/bg'
// Necessary for displaying datews with Romanian translations
import 'moment/dist/locale/ro'

import { getLanguageByCode } from '~/utils/lang-utils'

interface DatePickerProviderProps {
  children: JSX.Element | JSX.Element[]
}

function DatePickerProvider({ children }: DatePickerProviderProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  moment.locale(getLanguageByCode(language))

  return (
    <LocalizationProvider
      adapterLocale={language}
      dateAdapter={AdapterMoment}
      localeText={{
        okButtonLabel: t('general.ok'),
        clearButtonLabel: t('general.clear'),
        cancelButtonLabel: t('general.cancel'),
        todayButtonLabel: t('views.snapshotsTable.today'),
      }}
    >
      {children}
    </LocalizationProvider>
  )
}

export default DatePickerProvider
